<template>
  <div :class="['app-container', { 'bdc-list-page': isBdc }]" id="driver">
    <!-- 工具栏 -->
    <div class="filter-container" :class="{ 'bdc-filter-bar': isBdc }">
      <el-button class="filter-item" type="primary" size="small" icon="el-icon-circle-plus-outline" @click="handleAdd">添加用户</el-button>
      <el-input id="UserSearch-Guide" class="filter-item" size="small" v-model="search" clearable placeholder="登录名邮箱姓名模糊查询" style="width:200px;"></el-input>
      <el-select class="filter-item" v-model="authType" size="small" placeholder>
        <el-option label="全部用户" value=''></el-option>
        <el-option label="英雄用户" value="1"></el-option>
        <el-option label="非英雄用户" value="2"></el-option>
        <el-option label="未认证用户" value="0"></el-option>
      </el-select>

      <!-- 表格header 筛选 -->
      <div class="filterTableHeader" style="float:right;" v-if="isAdmin_Vip && !isBdc">
        <el-popover width="400" trigger="click">
          <el-button slot="reference" size="small" icon="el-icon-s-grid" style="font-size: 16px;padding:5px 10px;" title="筛选列"><i class="el-icon-caret-bottom"></i></el-button>
          <el-checkbox-group class="checkbox-table-headers" v-model="checkboxTitle">
            <el-checkbox v-for="(item,index) in tableTheadOptions" :key="index" :label="item">{{item[Object.keys(item)[0]]}}</el-checkbox>
          </el-checkbox-group>
        </el-popover>
      </div>
    </div>

    <!-- 表格 -->
    <div ref="bdcTableArea" :class="{'bdc-table-area': isBdc}">
    <el-table class="grayTableTile" size="small" v-loading="listLoading" :data="tableList" border style="width: 100%" :height="tableHeightDaily" @sort-change="handleAgeSortChange">
      <el-table-column v-for="(item,index) in tableTheads" :key="index" :label="item[Object.keys(item)[0]]" :prop="Object.keys(item)[0]" sortable='custom' min-width="130px">
        <template slot-scope="scope">
          <span v-if="Object.keys(item)[0] == 'username'" style="color:#646cf5;cursor: pointer;" @click="juesexiangqing(scope.row)">{{ scope.row.username}} {{scope.row.email ? '/' + scope.row.email : ''}}</span>
          <span v-else-if="Object.keys(item)[0] == 'locked'">{{ scope.row[Object.keys(item)[0]] | lockedguolv}}</span>
          <span v-else-if="Object.keys(item)[0] == 'authType'">{{scope.row[Object.keys(item)[0]] | authType}}</span>
          <span v-else>{{ scope.row[Object.keys(item)[0]]}}</span>
        </template>
      </el-table-column>

      <el-table-column width="340">
        <template slot="header">
          <span id="AddPermissions-Guide">操作</span>
        </template>

        <template slot-scope="scope">
          <div class="bdc-table-op-cell">
            <el-button type="text" class="bdc-table-op-muted" @click="tianjiaquanxian(scope.row)">添加分组</el-button>
            <el-button type="text" class="bdc-table-op-muted" @click="yonghuquanxian(scope.row)">添加权限</el-button>
            <span v-if="isAdmin_Vip">
              <el-button v-if="scope.row.locked == 0 || scope.row.locked == 3" type="text" class="bdc-table-op-muted" @click="suodingbtn(scope.row)">锁定</el-button>
              <el-button v-if="scope.row.locked == 1 || scope.row.locked == 4" type="text" class="bdc-table-op-muted" @click="jiesuobtn(scope.row)">解锁</el-button>
            </span>
            <el-button type="text" class="bdc-table-op-danger" @click="shanchujuese(scope.row)">删除</el-button>
          </div>
        </template>
      </el-table-column>

    </el-table>
    </div>

    <!-- 分页 -->
    <bdc-table-footer>
      <template v-if="isAdmin_Vip" #actions>
        <el-popover width="400" trigger="click">
          <bdc-column-filter-button slot="reference" />
          <el-checkbox-group class="checkbox-table-headers" v-model="checkboxTitle">
            <el-checkbox v-for="(item,index) in tableTheadOptions" :key="index" :label="item">{{item[Object.keys(item)[0]]}}</el-checkbox>
          </el-checkbox-group>
        </el-popover>
      </template>
      <pagination v-show="total>0" :auto-scroll="false" :background="!isBdc" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize" :class="isBdc ? 'bdc-table-pagination' : ''" />
    </bdc-table-footer>

    <!-- 添加用户弹窗 -->
    <create-user ref="create" @getAgainList="getList"></create-user>

    <!-- 用户详情 -->
    <user-info ref="info" @handleAddRoles="yonghuquanxian" @handleAddGroups="tianjiaquanxian"></user-info>

    <!--右侧抽屉 穿梭框 添加分组 -->
    <transfer v-if="drawer" ref="transfer" :title="drawertitle" @getTransferList="getTransferList" @handleSave="handleSave"></transfer>

  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import BdcTableFooter from '@/components/BdcTableFooter'
import BdcColumnFilterButton from '@/components/BdcTableFooter/BdcColumnFilterButton'
import { userlist, usersuoding, userjiesuo, userdelete, groupfilterHas, userdoAssignRole, rolefilterHasForUser, userdoAssignGroups } from '@Sys~/api/sys'
import { arrSlice, sortKeys } from '@/filters'
import CreateUser from '../components/createUser'
import UserInfo from '../components/userInfo'
import Transfer from '../components/transferCollapse'
import bdcListTableHeight from '@Sys~/utils/bdcListTableHeight'

const defaultFormThead = [
  { username: '登录名/邮箱' },
  { realname: '用户姓名' },
  { id: 'ID' },
  { locked: '状态' },
  { authType: '用户类型' },
  { updateTime: '最后登录时间' }
]

const defaultChecked = [
  { username: '登录名/邮箱' },
  { realname: '用户姓名' },
  { locked: '状态' },
  { authType: '用户类型' },
  { updateTime: '最后登录时间' }
]

export default {
  mixins: [bdcListTableHeight],
  components: { Pagination, BdcTableFooter, BdcColumnFilterButton, CreateUser, UserInfo, Transfer },
  data() {
    return {
      search: '',
      authType: "",
      isAdmin_Vip: this.$store.getters.roles.indexOf('admin') > -1 || this.$store.getters.roles.indexOf('vip') > -1,

      // 表格
      listLoading: false,
      originalCaseTable: [],// 排序原始数据
      caseTable: [], // 存放后端一次性返回的所有数据
      handCaseTable: [], // 存放处理假分页后的数据(等距切割)
      tableData: [], // 切割后页面应展示的数据
      tableTheadOptions: defaultFormThead,
      checkboxTitle: defaultFormThead.filter(item => !item.id), // 排除id项，并使用同一引用
      tableTheads: defaultChecked,

      total: 0,
      listQuery: {
        pageNo: 1,
        pageSize: 10
      },

      // 右侧抽屉
      drawer: false,
      drawertitle: "",
      jueseinfo: {}

    }
  },
  watch: {
    // 筛选table header
    checkboxTitle(valArr) {
      this.tableTheads = this.tableTheadOptions.filter(i => JSON.stringify(valArr).indexOf(JSON.stringify(i)) > -1)
    }
  },
  computed: {
    isBdc() {
      return process.env.VUE_APP_PROJECT_TYPE === 'bdc'
    },
    // 筛选列表表
    tableList() {
      let caseTable = this.caseTable
      const search = this.search.toLowerCase().replace(/\s+/g, "");
      if (search || this.authType) {
        if (this.authType) {
          caseTable = this.caseTable.filter(data => {
            return (String(data['id']).toLowerCase().indexOf(search) > -1 || String(data['username']).toLowerCase().indexOf(search) > -1 || String(data['phone']).toLowerCase().indexOf(search) > -1 || String(data['email']).toLowerCase().indexOf(search) > -1
              || String(data['realname']).toLowerCase().indexOf(search) > -1) && String(data['authType']) == this.authType
          })
        } else {
          console.log('默认条件下的搜索：', search)
          caseTable = this.caseTable.filter(data => {
            return (String(data['id']).toLowerCase().indexOf(search) > -1 || String(data['username']).toLowerCase().indexOf(search) > -1 || String(data['phone']).toLowerCase().indexOf(search) > -1  || String(data['email']).toLowerCase().indexOf(search) > -1
              || String(data['realname']).toLowerCase().indexOf(search) > -1)
          })
        }
      }

      this.total = caseTable.length
      // 将一维数组切割成二维数组
      this.handCaseTable = arrSlice(caseTable, this.listQuery.pageSize)
      this.tableData = this.handCaseTable[this.listQuery.pageNo - 1]
      return this.tableData
    }
  },
  filters: {
    lockedguolv(value) {
      if (value == "0") {
        return "正常";
      } else if (value == "1") {
        return "离职锁定";
      } else if (value == "2") {
        return "待审核";
      } else if (value == "3") {
        return "正常";
      } else if (value == "4") {
        return "过期锁定";
      }
    },

    authType(type) {
      const typeMap = {
        0: '未认证用户',
        1: '英雄用户',
        2: '非英雄用户'
      }
      return typeMap[type]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取列表
    getList() {
      this.listLoading = true
      userlist().then(response => {
        this.listLoading = false
        if (response.code == 1) {
          this.caseTable = response.data
          this.originalCaseTable = JSON.parse(JSON.stringify(this.caseTable))
        }
      })
    },

    // 监听排序变化
    handleAgeSortChange(e) {
      if (e.order) {
        const order = e.order == 'descending' ? false : true
        this.caseTable.sort(sortKeys(e.prop, order))
      } else {
        this.caseTable = JSON.parse(JSON.stringify(this.originalCaseTable))
      }
    },

    // 添加用户
    handleAdd() {
      this.$refs['create'].init()
    },

    // 角色详情
    juesexiangqing(row) {
      this.$refs['info'].init(row)
    },

    // 添加分组
    tianjiaquanxian(row) {
      this.drawer = true
      this.jueseinfo = row
      this.$nextTick(() => {
        this.drawertitle = "添加至用户组：" + row.realname;
        this.$refs['transfer'].init("groups", row)

        this.$refs['transfer'].sourceList = [
          {
            title: '', // Collapse 折叠面板 标题
            name: '1', // Collapse 折叠面板 序号
            checkStrictly: true, // 不关联
            toSelectedList: { // 待选数据
              title: '待选', // 待选标题
              search: '',
              disabledSearch: true,
              treeload: true,
              list: []
            },
            selectedList: { // 已选数据
              title: '已选',
              search: '',
              disabledSearch: true,
              treeload: false,
              rawList: [],
              list: []
            }
          },
        ]
      })
    },

    // 添加权限
    yonghuquanxian(row) {
      this.drawer = true
      this.jueseinfo = row
      this.$nextTick(() => {
        this.drawertitle = "添加角色至用户：" + row.realname;
        this.$refs['transfer'].init("purview", row)
        this.$refs['transfer'].sourceList = [
          {
            title: '', // Collapse 折叠面板 标题
            name: '1', // Collapse 折叠面板 序号
            checkStrictly: true, // 不关联
            toSelectedList: { // 待选数据
              title: '待选', // 待选标题
              search: '',
              disabledSearch: true,
              treeload: true,
              list: []
            },
            selectedList: { // 已选数据
              title: '已选',
              search: '',
              disabledSearch: true,
              treeload: false,
              rawList: [],
              list: []
            }
          },
        ]
      })
    },

    // 获取 权限 或 分组的数据
    getTransferList(source, row) {
      // console.log(source)
      if (source == "groups") { // 添加分组
        // 获取待选组列表
        groupfilterHas(row.id).then(response => {
          this.$refs['transfer'].sourceList[0].toSelectedList.treeload = false
          if (response.code == 1) {
            if (response.data.length > 0) {
              this.$refs['transfer'].sourceList[0].toSelectedList.disabledSearch = false
            }
            this.$refs['transfer'].sourceList[0].toSelectedList.list = this.$refs['transfer'].transformList(response.data)
          }
        });
      }

      if (source == "purview") { // 添加权限
        // 获取待选组列表
        rolefilterHasForUser(row.id).then(response => {
          this.$refs['transfer'].sourceList[0].toSelectedList.treeload = false
          if (response.code == 1) {
            if (response.data.length > 0) {
              this.$refs['transfer'].sourceList[0].toSelectedList.disabledSearch = false
            }
            this.$refs['transfer'].sourceList[0].toSelectedList.list = this.$refs['transfer'].transformList(response.data)
          }
        });
      }
    },

    // 确定添加 分组，添加权限
    handleSave(list, row, source) {
      let ids = []
      list[0].selectedList.list.forEach(item => {
        ids.push(item.id)
      })
      if (source == "purview") { // 权限
        const data = {
          userId: [row.id],
          roleId: ids
        }
        userdoAssignRole(data).then(response => {
          this.$refs['transfer'].butnLoading = false;
          if (response.code == 1) {
            this.$message({
              message: "保存成功",
              type: "success"
            });

            this.$refs['transfer'].drawer = false
            this.drawer = false
            if (this.$refs['info'].juesequanxianlist) {
              this.$refs['info'].getList(row)
            } else {
              this.getList()
            }
          }
        });
      } else { // 组
        const data = {
          userId: [row.id],
          groupId: ids
        }
        userdoAssignGroups(data).then(response => {
          if (response.code == 1) {
            this.$message({
              message: "保存成功",
              type: "success"
            });
            this.$refs['transfer'].butnLoading = false;
            this.$refs['transfer'].drawer = false
            this.drawer = false
            if (this.$refs['info'].juesequanxianlist) {
              this.$refs['info'].getList(row)
            } else {
              this.getList()
            }
          }
        });
      }
    },

    // 锁定
    suodingbtn(row) {
      this.$confirm('确认锁定用户： "' + row.realname + '" 吗？').then(_ => {
        usersuoding(row.id).then(response => {
          if (response.code == 1) {
            this.$message({
              message: "锁定成功",
              type: "success"
            });
            this.getList();
          }
        });
      }).catch(_ => { });
    },

    // 解锁
    jiesuobtn(row) {
      this.$confirm('确认解锁用户： "' + row.realname + '" 吗？').then(_ => {
        userjiesuo(row.id).then(response => {
          if (response.code == 1) {
            this.$message({
              message: "解锁成功",
              type: "success"
            });
            this.getList();
          }
        });
      }).catch(_ => { });
    },

    // 删除
    shanchujuese(row) {
      // 删除角色
      this.$confirm('确认删除用户： "' + row.realname + '" 吗？点击确定将一并删除此用户的对应权限！').then(_ => {
        userdelete(row.id).then(response => {
          if (response.code == 1) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.getList();
          }
        });
      }).catch(_ => { });
    }
  }
}
</script>